export const CRM_USER_SETTINGS_UPDATED_EVENT = "crm-user-settings-updated";
